export class KitImagem {
  id: number;
  idPainel: number;
  idMarcaInversor: number;
  imagem: string;
}
